import { Pipe, PipeTransform } from '@angular/core';
import { DocumentTag } from '@app/features/documents/document.model';

@Pipe({
  name: 'documentTagToTextIcon',
})
export class DocumentTagToTextIconPipe implements PipeTransform {
  transform(tag: DocumentTag): string {
    switch (tag) {
      case 'identityDocument':
        return 'ID';
      case 'residentPermit':
        return 'TSJ';
      case 'proofOfResidence':
        return 'JdD';
      case 'proofOfAccommodation':
        return 'JdH';
      case 'hostIdentityDocument':
        return 'IDH';
      case 'hostProofOfResidence':
        return 'JdDH';
      case 'rib':
        return 'RIB';
      case 'socialSecurityCertificate':
        return 'ASS';
      case 'contract':
        return 'CTR';
      case 'signedContract':
        return 'SIG';
      case 'drivingLicense':
        return 'PER';
      case 'securitySheet':
        return 'FDS';
      case 'signedDrivingLicense':
        return 'PER';
      case 'signedSecuritySheet':
        return 'FDS';
      case 'amendment':
        return 'AV';
      case 'signedAmendment':
        return 'AVS';
    }
  }
}
